import { useUpdateProduct } from "../../../api";
import { useGetProduct } from "../../../api";
import { useToastContext } from "../../../providers/toastContext";
import { useNavigate, useParams } from "react-router-dom";
import Page from "../../../Containers/Page";
import FlexCentered from "../../../Containers/FlexCentered";
import Heading from "../../../Components/Heading";
import EditProductDataForm from "../../../Forms/productForms/EditProductDataForm";
import { useEffect } from "react";
import getApiStatusPage from "../../APIStatusPage";

function EditProductDataPage() {
  const { productRef } = useParams();
  const updateProductApi = useUpdateProduct();
  const { createSuccessToast } = useToastContext();

  const getProductApi = useGetProduct({
    productRef,
    params: {
      //prettier-ignore
      fields: 'isArchived,seedLot,population,parentBusiness,reference,growingData,moistureContent,protein,hagberg,gluten,specificWeight,germinationRate,thousandGrainWeightGrams,DON,ZON,septoria,bunt',
      "populate[population]": "name",
      "populate[seedLot]": "reference,date",
      "populate[growingData/field]": "name,location",
      includeMassBalanceFigures: true,
    },
  });

  const product = getProductApi?.data?.product;

  const navigateTo = useNavigate();
  useEffect(() => {
    if (updateProductApi.data) {
      createSuccessToast("Product data updated");
      return navigateTo(`/dashboard/products/${product.reference}`);
    }
  });

  const statusPage = getApiStatusPage({
    apis: [
      {
        api: getProductApi,
        type: "Product",
        dataRequired: true,
      },
    ],
  });
  if (statusPage) return statusPage;

  return (
    <Page title="Product" className="px-[4vw]">
      <FlexCentered col className="pt-6">
        <Heading primary className={"text-hgGreen-1000 text-xl"}>
          Edit Product Data
        </Heading>
        <Heading secondary className="mb-8">
          {product.reference}
        </Heading>
      </FlexCentered>
      <EditProductDataForm
        product={product}
        updateProductApi={updateProductApi}
      />
    </Page>
  );
}

export default EditProductDataPage;
